import React from 'react';
import { i18n_style } from '@yi/i18n/phrases/i18n_style';

import { useLocale } from '../../../LocaleProvider';
import { RadioButtonsListWithFilter } from '../RadioButtonsListWithFilter';
import { RefinementAccordion } from '../RefinementAccordion';

const FACET_NAME = 'ALGOLIA_style';

export const StyleSelectAccordion: React.FC = () => {
  const { locale } = useLocale();

  return (
    <RefinementAccordion displayName={i18n_style(locale)} attribute={FACET_NAME}>
      {({ items, refine, onItemClick, clear }) => {
        return (
          <RadioButtonsListWithFilter
            items={items}
            refine={refine}
            onItemClick={onItemClick}
            clear={clear}
          />
        );
      }}
    </RefinementAccordion>
  );
};
